import * as React from 'react';

import classnames from 'classnames';

type RadioGroupContextProps = {
    name: string;
    selectedValue: string | null | undefined;
    onChange: (newValue: Readonly<string>) => void;
    inline?: boolean;
    shouldSpaceHorizontally?: boolean;
};

export type RadioGroupProps = RadioGroupContextProps & {
    children: React.ReactNode[];
    size?: 'normal' | 'big';
    spacing?: 0 | 2 | 8 | 16 | 24 | 32;
    toolTip?: string;
};

const defaultContextValue = {name: 'default', selectedValue: null, onChange: () => {}} as const;

export const RadioGroupContext = React.createContext<RadioGroupContextProps>(defaultContextValue);

export function RadioGroup({
    size = 'normal',
    children,
    spacing = 8,
    toolTip,
    ...props
}: RadioGroupProps) {
    const className = classnames({
        flex: true,
        'flex-dir-col': !props.inline,
        'font-size-normal': size === 'big',
        [`gap-${spacing}`]: !props.inline || props.shouldSpaceHorizontally,
    });

    return (
        <RadioGroupContext.Provider value={props}>
            <div className={className} role='radiogroup' data-tip={toolTip}>
                {children}
            </div>
        </RadioGroupContext.Provider>
    );
}
